import type { ReactElement } from "react"
import { NavLink } from "react-router-dom"

import { Button } from "@/components/ui/button"

/**
 * Define o `nativeButton` do Base UI para triggers com `render`
 * (equivalente ao antigo `asChild` do Radix).
 *
 * Apenas elementos que se comportam como botão recebem `true`; links
 * (`<a>`, `NavLink`) recebem `false` para manter o comportamento nativo de
 * navegação (sem `role="button"` nem handlers de teclado duplicados).
 */
export function nativeButtonFor(child: ReactElement): boolean {
  const type = child.type as unknown
  if (type === Button || type === "button") return true
  if (type === NavLink || type === "a") return false
  return true
}
